import { useEffect, useState } from 'react';

// Phones get their own game screen: portrait up to 600px wide, and phones
// turned sideways (short and touch-driven). Tablets and every desktop window
// taller than 500px keep the wide layout. The start page's pre-rendered copy
// switches at the same 600px (scripts/prerender.js).
export const PHONE_QUERY = '(max-width: 600px), (max-height: 500px) and (pointer: coarse)';

export const isPhoneNow = () => {
    try {
        return window.matchMedia(PHONE_QUERY).matches;
    } catch (error) {
        return false;
    }
};

const usePhone = () => {
    const [phone, setPhone] = useState(isPhoneNow);
    useEffect(() => {
        let query;
        try {
            query = window.matchMedia(PHONE_QUERY);
        } catch (error) {
            return undefined;
        }
        const update = () => setPhone(query.matches);
        update();
        query.addEventListener('change', update);
        return () => query.removeEventListener('change', update);
    }, []);
    return phone;
};

/**
 * Marks the page while a phone table is showing. Pop-ups and toasts are drawn
 * outside the table, so their phone styles hang off html.phone-play
 * (see Board/board.css); desktop never gets the class.
 */
export const usePhoneTable = (active) => {
    useEffect(() => {
        if (!active) {
            return undefined;
        }
        const root = document.documentElement;
        root.classList.add('phone-play');
        return () => root.classList.remove('phone-play');
    }, [active]);
};

export default usePhone;
